import { CurrencyEnum } from '../../enums';
import { CurrencySymbolType } from '../../services/subscription/types';

export enum ReportingCall {
  getOrderDetail,
  getOpenPositions,
  getAccountTradeHistory,
  getAccountPendingOrders,
  getPeopleAlsoTradeData,
  getBuiyngPower,
  getAvailableCash,
  getAccountTradeHistoryFirstAndLastTrade,
}

export interface PeopleAlsoTradeParams {
  accountReferenceId: string;
  daysBack: number;
  symbolNumber?: number;
  tenNAccounstOnly: boolean;
}

export enum FxOrderType {
  Buy = 1,
  Sell = 2,
}

export enum FxOrderSideType {
  Buy = '1',
  Sell = '2',
}

export enum FxOrderStatus {
  New = 0,
  Fill = 2,
  Rejected = 4,
}

export interface PeopleAlsoTradeItem {
  symbol: string;
  rowNumber: number;
}

export interface FxCommission {
  commCurr: CurrencyEnum,
  commValue: number,
}

export interface FxOrder {
  boughtAmountCurr: CurrencyEnum;
  boughtAmountValue: number;
  comissions: FxCommission[];
  exchangeRate: number;
  lastUpdatedDate: string;
  orderDate: string;
  orderId: string;
  orderStatus: FxOrderStatus;
  pages: number;
  rowNumber: number;
  side: FxOrderSideType;
  soldAmountCurr: CurrencyEnum;
  soldAmountValue: number;
  symbol: CurrencySymbolType;
  executionId: number;
  fillDate: string;
  orderCurrency: CurrencyEnum;
  tenNStatus: FxOrderStatus;
}
